var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"runningprediction"}},[_c('p',[_vm._v("Do I think that "+_vm._s(_vm.weirName)+" will be running today?")]),_c('h2',[_vm._v(_vm._s(_vm.result))])])}
var staticRenderFns = []

export { render, staticRenderFns }